export default {
  lang: 'en-GB',
  user: {
    name: null,
    email: null
  },
  env: {
    menu: true,
    api_base: null,
    api_token: null,
    api_secret: null,
    api_id: null
  }
}



// WEBPACK FOOTER //
// ./src/store/state.js